import wpcf7Structure from "./scripts/wpcf7-structure";
import { extendJquery,validateEmail } from "./scripts/utils";
import skipLinkFocusFix from "./scripts/skip-link-focus-fix";
import  popup from "./scripts/popup";
import navigation from "./scripts/navigation";
import setupAnimations from "./scripts/animations";
import ready from "./scripts/ready";

ready(()=>{
    setupAnimations();
    popup();
})

window.addEventListener('load', initMasonryGalleries);

function initMasonryGalleries() {
    const galleries = document.querySelectorAll('.wp-block-gallery.is-masonry');
    if (!galleries.length || typeof Masonry === 'undefined') return;

    galleries.forEach(gallery => {
        new Masonry(gallery, {
            itemSelector: '.wp-block-image',
            columnWidth: '.wp-block-image',
            percentPosition: true,
            gutter: 10,
        });
    });
}

skipLinkFocusFix();
extendJquery();
wpcf7Structure();

navigation();

(function($){
    
    ready(()=>{
         // parallax des bannières
         $('.with-parallax').each(function(){
            $(this).children('img').parallax($(this),4,0);
        });
        // parallax de la bannière générale
        if($('.banner-parallax').length){
            $('.banner-parallax img').parallax($('.banner'),4,0);
        }
        $( window ).on( "resize", function() {
            $('body').css('--wp--custom--height-nav', $('#masthead').height()+"px");
        } );
        $('body').css('--wp--custom--height-nav', $('#masthead').height()+"px");
    });


     /* inscription a l'infolettre */
     $('.infolettre, .newsletter-form').submit(function(e){
        console.log("salut");
        e.preventDefault();
        var messageLogWrapper = $(this).find('.message-form');
        var messageLog = $(this).find('.cdm-message-ouput');
        if(!validateEmail($(this).find('input[name="email"]').val())){
            messageLog.text(siteData.traduction.emailError);
            messageLogWrapper.removeClass('success').addClass('invalid');
        }else{
            var data = {
                email: $(this).find('input[name="email"]').val(),
                lang: siteData.lang
            }

            if($(this).hasClass('full-name')){
                if($(this).find('input[name="firstname"]').val() == "" || $(this).find('input[name="lastname"]').val() == ""){
                    messageLog.text(siteData.traduction.titleError);
                    messageLogWrapper.removeClass('success').addClass('invalid');
                    return;
                }
                data.fname = $(this).find('input[name="firstname"]').val();
                data.lname = $(this).find('input[name="lastname"]').val();
            }

            wp.apiFetch({
                path: "codems/newsletter/subscription",
                method: 'POST',
                data: data
            }).then( res => {
                if(res.success){				
                    messageLog.html(res.message);
                    messageLogWrapper.removeClass('invalid').addClass('success');
                    
                }else{
                    messageLog.html(res.message);
                    messageLog.removeClass('success').addClass('error');
                }
            })
            
            return false;
        }
    });

    if($(window).width() <= 1024 && $('.blog-wrapper').length){
        $('.blog-wrapper .sidebar .sidebar-title').click(function(){
            $(this).siblings('ul').slideToggle();
        });
    }

    //menu sticky on scroll up
	var previousScrollTop = 0;

    $(document).scroll(function() {
		var y = $(this).scrollTop();
        var heightToSticky = 0;

		if(!$('body').hasClass('menu-open')){

            if(y > heightToSticky && y > 50){
                // retire la nav au scroll down et la fait apparaitre on scroll up
                if(y > previousScrollTop){
                    $('body').addClass('hide-nav'); 
                }else{
                    $('body').removeClass('hide-nav');
                }
            }  

            if(y > 400){
                $('body').addClass('bg-nav');
            }else{
                $('body').removeClass('bg-nav');
            }
		}		
		previousScrollTop = y;

	});

    // le bloc faq de yoast
    $('.schema-faq-question').click(function(){
        $(this).parent().toggleClass('open').find('.schema-faq-answer').slideToggle();
    });

    $(document).ready(function(){

        //remplit le champs poste dans une single et trigger le mouvement d'input
        if ($('body').hasClass('single-cdm_career_offer')) {
            var field = $('input[name="poste"]');
            if (field.length) {
                field.val($('h1').text()).parent().addClass('move');
            }
        }

        if($('.wpcf7-form').length){
            $('input,textarea').on('focus', function() {
                console.log('focus');
                $(this).parent().addClass('move');
            })
            
            $('input,textarea').on('focusout', function() {
                console.log('focusout');
                if(!$(this).val()) $(this).parent().removeClass('move');
            })
        }

        $('a[href="#formulaire-benevole"]').on('click', function(){
            $('input[name="poste"]').val($('h1').text()).parent().addClass('move');
        });

        if($('body').hasClass('single-implication')){
            if($('form.wpcf7-form').length){
                $('input[name="poste"]').val($('h1').text()).parent().addClass('move'); 
            }
        }
    });

})(jQuery);